import { Suspense } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SuspenseErrorBoundary } from 'forms-ai-lib/internal/components/errorBoundary/SuspenseErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuspenseWithErrorBoundary = ({
  children,
  loadingElement,
  errorElement,
  onError
}) => /*#__PURE__*/_jsx(SuspenseErrorBoundary, {
  fallback: errorElement,
  onError: onError,
  children: /*#__PURE__*/_jsx(Suspense, {
    fallback: loadingElement || /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      marginBlockStart: "1000"
    }),
    children: children
  })
});